export default __webpack_public_path__ + "static/robot-7443461a62cef3b56bd015528410ebb6.webp";